// 检查owner是否重复，这里是classification与position都相同情况下，owner还一样
const checkOwnerList = (ownerList: IOwnerList[] | null | undefined, isStudioModule: boolean) => {
  let isError = false;
  const errorOwnerList: IOwnerList[] = []; // 更新时，这个数据也可以是全部不报错的数据
  if (!Array.isArray(ownerList) || !ownerList?.length) {
    isError = true;
  } else {
    for (let i = 0, l = ownerList?.length; i < l; i++) {
      const t = ownerList?.[i];
      for (let j = 0, len = ownerList?.length; j < len; j++) {
        const k = ownerList?.[j];
        // 当外面和里面都是最后一条时，说明最后一条没重复，此时不能走continue的逻辑，不然数据就少了最后一条
        if (i === l - 1 && j === len - 1) {
          errorOwnerList.push({
            ...t,
            ownerError: false, // 改为不报错的状态，因为这里涉及到已经报错的更新时把报错态去除
          });
          break;
        }
        // 自己和自己比较，跳过
        if (i === j) continue;
        // 比较有无重复的owner，有的话记录这条数据报错并比较下一条
        if (
          t?.project_owner === k?.project_owner &&
          t?.position === k?.position &&
          // studio模块owner是输入的，所以比较name有无重复，iegg模块owner是下来搜索人员选择的，所以比较user_id有无重复
          (isStudioModule ? t?.name === k?.name : t?.user_id === k?.user_id)
        ) {
          if (!isError) isError = true;
          errorOwnerList.push({
            ...t,
            ownerError: true,
          });
          break;
        }
        // 一直比较到最后一条都没有重复，说明这条数据是没问题的
        if (j === len - 1) {
          errorOwnerList.push({
            ...t,
            ownerError: false, // 改为不报错的状态，因为这里涉及到已经报错的更新时把报错态去除
          });
        }
      }
    }
  }

  return {
    isError,
    errorOwnerList: errorOwnerList?.length
      ? errorOwnerList
      : [
        {
          project_owner: '',
          // id: null,
          // sort: null,
          link: '',
          name: '',
          position: '',
          user_id: '',
          ownerError: true,
        },
      ],
  };
};

const getReqParams = (originalList: IOwnerList[] | null, currentList: IOwnerList[] | null, isStudioModule: boolean) => {
  const result: {
    add?: IOwnerList[];
    delete?: number[]; // 删除的id
    update?: IOwnerList[];
  } = {
    add: undefined,
    delete: undefined,
    update: undefined,
  };
  if (!Array.isArray(currentList) || !currentList?.length) return result;
  const organization = isStudioModule ? 'studio' : 'iegg';
  // 先处理排序
  let maxSort = 0; // 找到历史数值中最大sort值
  if (Array.isArray(originalList) && originalList?.length) {
    for (let i = 0, l = originalList?.length; i < l; i++) {
      const t = originalList?.[i];
      if (t?.sort && t?.sort > maxSort) maxSort = t?.sort;
    }
  }
  // 给每个数据整理好sort值，没有sort值时在历史数据最大sort值的基础上不断累加赋值，有sort值还是用原来的
  const sortList: IOwnerList[] = [];
  for (let i = 0, l = currentList?.length; i < l; i++) {
    const t = currentList?.[i];
    if (!t?.sort) maxSort += 1;
    sortList.push(t?.sort ? t : { ...t, sort: maxSort });
  }

  // 再处理好哪些是add、delete、update标识出来
  let adds;
  let deletes;
  let updates;
  if (Array.isArray(originalList) && originalList?.length) {
    // 新增的数据
    for (let i = 0, l = sortList?.length; i < l; i++) {
      const t = sortList?.[i];
      if (!t?.id) {
        if (!adds) adds = [];
        adds.push({
          ...t,
          organization,
          user_name: t?.name,
          name: undefined,
          ownerError: undefined,
          linkError: undefined,
        });
      }
    }
    // 删除的数据和更新的数据
    for (let i = 0, l = originalList?.length; i < l; i++) {
      const t = originalList?.[i];
      const flag = sortList?.some((it) => it?.id === t?.id && it?.id);
      if (!flag) {
        // 删除的数据
        if (!deletes) deletes = [];
        deletes.push(t?.id as number);
      } else {
        // 更新的数据
        const updateItemMsg = sortList?.find((it) => it?.id === t?.id && it?.id);
        // 这条数据是否有更新
        const isUpdate = updateItemMsg
          ? t?.project_owner !== updateItemMsg?.project_owner ||
            t?.name !== updateItemMsg?.name ||
            t?.user_id !== updateItemMsg?.user_id ||
            t?.position !== updateItemMsg?.position ||
            t?.link !== updateItemMsg?.link
          : false;
        if (isUpdate && updateItemMsg) {
          if (!updates) updates = [];
          updates.push({
            ...updateItemMsg,
            organization,
            user_name: updateItemMsg?.name,
            name: undefined,
            ownerError: undefined,
            linkError: undefined,
          });
        }
      }
    }
  } else {
    // 初始没有数据的话，那全部都是新增的数据
    adds = sortList?.map((t) => ({
      ...t,
      organization,
      user_name: t?.name,
      name: undefined,
      ownerError: undefined,
      linkError: undefined,
    }));
  }
  result.add = adds;
  result.delete = deletes;
  result.update = updates;

  return result;
};

export { checkOwnerList, getReqParams };
